import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { ResearchApproach } from './components/ResearchApproach';
import { Certification } from './components/Certification';
import { FeaturedResearch } from './components/FeaturedResearch';
import { ProductReviews } from './components/ProductReviews';
import { MediaInsights } from './components/MediaInsights';
import { SupportCTA } from './components/SupportCTA';
import { Footer } from './components/Footer';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
export function App() {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <ResearchApproach data-id="element-5" />
        <FeaturedResearch data-id="element-6" />
        <Certification data-id="element-7" />
        <ProductReviews data-id="element-8" />
        <MediaInsights data-id="element-9" />
        <SupportCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}